<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('매장')">
              <StorePicker v-model="searchForm.storeCd" :options="store" @change="search" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('외부 코드')">
              <el-input v-model="searchForm.externalCode" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('StoreExternalCodeSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('StoreExternalCodeAdd')"
        :size="size"
        @click="request"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('StoreExternalCodeUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('StoreExternalCodeDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <el-table-column :label="$t('외부 코드')" prop="externalCode" min-width="200" sortable></el-table-column>
      <el-table-column
        :label="$t('파트너 구분')"
        prop="partnerTp.nm"
        min-width="200"
        align="center"
        sortable></el-table-column>
    </el-table>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-tabs value="info">
              <el-tab-pane :label="$t('기본 정보')" name="info">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item :label="$t('매장')" required>
                      <StorePicker
                        v-if="'I' === inputForm.statu"
                        v-model="inputForm.store.storeCd"
                        :options="store"
                        @change="storeInputSelect" />
                      <span v-else class="show_cd">{{ inputForm.store.storeNmLan }}</span>
                    </el-form-item>
                    <el-form-item :label="$t('외부 코드')" :error="formError.externalCode" required>
                      <el-input v-model="inputForm.externalCode" maxlength="50" clearable show-word-limit> </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('파트너 구분')" :error="formError['partnerTp.cd']" required>
                      <code-combo
                        :data="partnerTp"
                        :model="inputForm.partnerTp.cd"
                        @change="inputForm.partnerTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 대리점
import StorePicker from '@/components/store/StorePicker.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { STORE_OPTIONS_API, firstStoreOf, storeLansOf, storeOptionsOf, storeOptionsQuery } from '@/utils/storeOptions'
import storeOptionResolver from '@/mixins/storeOptionResolver'

export default {
  components: { StorePicker },

  mixins: [mainVueMixin, storeOptionResolver],
  data: function () {
    var data = initData()
    data.url = '/storeExternalCode'
    data.store = []
    data.partnerTp = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.lans = []
    data.popTableData = []

    data.dictionaryDialogFormVisible = false
    data.searchText = ''

    data.closeDialogVisible = false
    return data
  },
  created: function () {
    this.initPartnerTp()
    this.initStore()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(function () {}.bind(this), 500)
      },
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        storeCd: null,
        externalCode: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        id: 0,
        externalCode: '',
        store: { storeCd: null },
        partnerTp: { cd: null, nm: '' },
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        externalCode: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].id
      }
    },
    // 매장 자동 검색 — 셀렉트 전용 경량 조회다. URL·조건은 [storeOptionsQuery] 한 곳이 소유한다
    initStore: function () {
      this.mainVue.$axios.search(
        STORE_OPTIONS_API,
        storeOptionsQuery(),
        function (result) {
          this.store = storeOptionsOf(result)

          // 매장이 하나도 없는 계정(사업장 없음)은 빈 셀렉트·빈 표가 옳다 — 매장 축 없는 목록 조회는
          // 서버가 거절하므로 조회 자체를 건너뛴다
          const first = firstStoreOf(this.store)
          if (first == null) return

          // 검색 칸의 기본 매장과 첫 조회는 [StorePicker] 가 소유한다 — 화면마다 복제하지 않는다
          this.inputForm.store.storeCd = first.storeCd
          this.inputForm.defaultLan = first.defaultLan

          this.initStoreLans(first)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정
    // 순서(기본 언어가 맨 앞)는 [storeLansOf] 한 곳이 소유한다
    initStoreLans: function (store) {
      this.lans = storeLansOf(store)
    },
    // 파트너 구분 조회
    initPartnerTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/PARTNER_TP',
        null,
        function (result) {
          this.partnerTp = result
        }.bind(this)
      )
    },
    // 고른 매장의 메타데이터를 폼에 적는다 — 진입점 둘(사람·씨앗)은 [storeOptionResolver] 가 갖고
    // 화면은 이 본문만 구현한다. 못 얻으면 아무것도 바꾸지 않는다
    applyStoreOption: async function (storeCd, pending) {
      const option = await pending
      if (!option) return

      // 디폴트 언어 설정
      this.initStoreLans(option)
    },
    // 추가
    request: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('매장 외부 코드 추가')
      this.formError = this.initFormError()

      if (this.store.length > 0) {
        this.inputForm.store = { storeCd: util.copyObj(this.searchForm.storeCd) }
        this.storeSeedSelect(this.inputForm.store.storeCd)
      }

      this.inputForm.partnerTp = this.partnerTp.length > 0 ? util.copyObj(this.partnerTp[0]) : { cd: null, nm: '' }

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.id,
        function (result) {
          result.statu = 'U'
          result.title = this.$t('매장 외부 코드 수정')

          this.inputForm = result

          this.formError = this.initFormError()

          this.storeSeedSelect(this.inputForm.store.storeCd)

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('매장 외부 코드 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.id,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    searchDictionary: function (searchText) {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'partnerTp' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this),
        true
      )
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          this.inputForm.smenuOptTpNm = row[this.lans[i].id]
        } else {
          // 타언어 순서대로 등록
          this.inputForm.smenuOptTpInfos[i - 1].smenuOptTpInfoNm = row[this.lans[i].id]
        }
      }

      this.dictionaryDialogFormVisible = false
    },
  },
}
</script>
